/* eslint-disable no-unused-vars */
import { useState } from "react";
import * as types from "./types";
import API from "../../services/api";
import cloneDeep from "lodash/cloneDeep";
import { taxPayerData, contributorData, duplicateData } from "./selectors";
import { unset } from "lodash";
import { failed, loadingStart } from "../General/actions";

export function loadTaxPayerData(taxPayer) {
  return {
    type: types.LOAD_TAXPAYER,
    taxPayer,
  };
}

export function loadContributorData(contributor) {
  return {
    type: types.LOAD_CONTRIBUTOR,
    contributor,
  };
}

export function setDuplicateData() {
  return {
    type: types.SET_DUPLICATE_DATA,
  };
}

/* Requests*/

export function getTaxPayerData() {
  return async (dispatch, getState) => {
    dispatch(loadingStart());
    const contributor = contributorData(getState());
    const copyCont = cloneDeep(contributor);
    let cuit = null;
    const dupData = duplicateData(getState());
    if (dupData) {
      cuit = contributorData(getState()).cuit;
    } else {
      cuit = taxPayerData(getState()).cuit;
    }
    try {
      const response = await API.user.getTaxPayerData(cuit);
      dispatch(loadTaxPayerData(response.data));
    } catch (e) {
      unset(copyCont, "address");
      if (dupData) {
        dispatch(loadTaxPayerData(copyCont));
      }
      dispatch(failed("Error al cargar los datos"));
    }
  };
}

export function getContributorData() {
  return async (dispatch, getState) => {
    dispatch(loadingStart());
    const cuit = contributorData(getState()).cuit;
    try {
      const response = await API.user.getContributorData(cuit);
      dispatch(loadContributorData(response.data));
    } catch (e) {
      dispatch(failed("Error al cargar los datos"));
    }
  };
}

export function modifyTaxPayerFields(field, value) {
  return async (dispatch, getState) => {
    const taxPayer = taxPayerData(getState());
    const copyTaxPayer = cloneDeep(taxPayer);
    copyTaxPayer[field] = value;
    dispatch(loadTaxPayerData(copyTaxPayer));
  };
}

export function modifyContributorFields(field, value) {
  return async (dispatch, getState) => {
    const contributor = contributorData(getState());
    const copyContributor = cloneDeep(contributor);
    copyContributor[field] = value;
    dispatch(loadContributorData(copyContributor));
  };
}
